import React from 'react';

const FaqArea = () => {
    return (
        <div className="faq__page section-padding">
            <div className="container">

                {/* TITLE */}
                <div className="faq__area-right-title mb-40" style={{ textAlign: "center" }}>
                    <span className="subtitle" style={{ color: "#111" }}>
                        SIKÇA SORULAN SORULAR
                    </span>

                    <h2 style={{ color: "#111", fontSize: "36px" }}>
                    Proje ve Hizmetlerimiz Hakkında
                    </h2>
                </div>

                <div className="row jc-center">
                    <div className="col-xl-10">

                    <div id="accordionExample">

{/* ITEM 1 */}
<div className="faq-item">
    <h5
        className="icon collapsed"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
    >
        Ayyıldız İnşaat hangi alanlarda hizmet vermektedir?

        <i className="fa-regular fa-plus"></i>
        <i className="fa-regular fa-minus"></i>
    </h5>

    <div
        id="collapseOne"
        className="faq-item-body collapse"
        data-bs-parent="#accordionExample"
    >
        <p>
            Endüstriyel yapılar, üretim tesisleri, ticari projeler, ofis binaları, konut projeleri, okullar, sosyal tesisler ve altyapı çalışmaları dahil olmak üzere geniş bir yelpazede anahtar teslim inşaat çözümleri sunmaktayız. Ayrıca proje yönetimi, planlama ve taahhüt süreçlerini de uçtan uca yürütüyoruz.
        </p>
    </div>
</div>

{/* ITEM 2 */}
<div className="faq-item">
    <h5
        className="icon collapsed"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
    >
        Firmanızın sektördeki deneyimi nedir?

        <i className="fa-regular fa-plus"></i>
        <i className="fa-regular fa-minus"></i>
    </h5>

    <div
        id="collapseTwo"
        className="faq-item-body collapse"
        data-bs-parent="#accordionExample"
    >
        <p>
            1987 yılından bu yana inşaat sektöründe faaliyet göstermekteyiz. Kurumsal tecrübemiz ve uzman kadromuz ile birçok farklı ölçekte projeyi başarıyla tamamladık ve sektörde güvenilir bir marka haline geldik.
        </p>
    </div>
</div>

{/* ITEM 3 */}
<div className="faq-item">
    <h5
        className="icon collapsed"
        data-bs-toggle="collapse"
        data-bs-target="#collapseThree"
    >
        Proje süreciniz nasıl ilerliyor?

        <i className="fa-regular fa-plus"></i>
        <i className="fa-regular fa-minus"></i>
    </h5>

    <div
        id="collapseThree"
        className="faq-item-body collapse"
        data-bs-parent="#accordionExample"
    >
        <p>
            Süreç; öncelikle proje danışmanlığı ve ihtiyaç analizi ile başlar. Ardından keşif çalışmaları yapılır, teklif hazırlanır ve proje ihale sürecine alınır. Onay sonrası planlama yapılır ve tüm süreç anahtar teslim olarak profesyonel ekiplerimiz tarafından yürütülür.
        </p>
    </div>
</div>

{/* ITEM 4 */}
<div className="faq-item">
    <h5
        className="icon collapsed"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFour"
    >
        Yeni bir proje için nasıl iletişime geçebilirim?

        <i className="fa-regular fa-plus"></i>
        <i className="fa-regular fa-minus"></i>
    </h5>

    <div
        id="collapseFour"
        className="faq-item-body collapse"
        data-bs-parent="#accordionExample"
    >
        <p>
            İletişim sayfamız üzerinden veya doğrudan telefon ve e-posta kanallarımız aracılığıyla bize ulaşabilirsiniz. Uzman ekibimiz proje detaylarınızı değerlendirerek size en uygun çözüm önerisini sunacaktır.
        </p>
    </div>
</div>

{/* ITEM 5 - NEW */}
<div className="faq-item">
    <h5
        className="icon collapsed"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFive"
    >
        Anahtar teslim proje hizmeti sunuyor musunuz?

        <i className="fa-regular fa-plus"></i>
        <i className="fa-regular fa-minus"></i>
    </h5>

    <div
        id="collapseFive"
        className="faq-item-body collapse"
        data-bs-parent="#accordionExample"
    >
        <p>
            Evet. Tüm projelerimizi planlama, tasarım, uygulama ve teslim aşamalarını kapsayan anahtar teslim model ile yürütmekteyiz. Sürecin tamamı profesyonel ekiplerimiz tarafından yönetilmektedir.
        </p>
    </div>
</div>

{/* ITEM 6 - NEW */}
<div className="faq-item">
    <h5
        className="icon collapsed"
        data-bs-toggle="collapse"
        data-bs-target="#collapseSix"
    >
        Projelerde kalite ve güvenlik standartlarınız nelerdir?

        <i className="fa-regular fa-plus"></i>
        <i className="fa-regular fa-minus"></i>
    </h5>

    <div
        id="collapseSix"
        className="faq-item-body collapse"
        data-bs-parent="#accordionExample"
    >
        <p>
            Tüm projelerimizde ulusal ve uluslararası inşaat standartlarına uygunluk esas alınır. Kalite kontrol süreçleri düzenli olarak uygulanır ve iş güvenliği en üst seviyede sağlanır.
        </p>
    </div>
</div>

</div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default FaqArea;